import { createAction } from '../utils/store';

export const updateOrganizationName = createAction('UPDATE_ORGANIZATION_NAME');
export const getOrganizationDetails = createAction('GET_ORGANIZATION_DETAILS');
export const createOrganization = createAction('CREATE_ORGANIZATION');
export const createApplication = createAction('CREATE_APPLICATION');
export const updateApplication = createAction('UPDATE_APPLICATION');
export const deleteApplication = createAction('DELETE_APPLICATION');
export const getApplications = createAction('GET_APPLICATIONS');
export const setCurrentApplication = createAction('SET_CURRENT_APPLICATION');
export const setBillingDetails = createAction('SET_BILLING_DETAILS');
export const updateBilling = createAction('UPDATE_BILLING');
export const setInvoices = createAction('SET_INVOICES');
export const setDefaultAccount = createAction('SET_DEFAULT_ACCOUNT');
export const deletePaymentSource = createAction('DELETE_PAYMENT_SOURCE');
export const verifyBankAccount = createAction('VERIFY_BANK_ACCOUNT');
export const setUsers = createAction('SET_USERS');
export const inviteUser = createAction('INVITE_USER');
export const deleteUser = createAction('DELETE_USER');
export const setCards = createAction('SET_CARDS');
export const setContracts = createAction('SET_CONTRACTS');
export const createContract = createAction('CREATE_CONTRACT');
export const updateCustomer = createAction('UPDATE_CUSTOMER');
export const createBilling = createAction('CREATE_BILLING');
export const getProfile = createAction('GET_PROFILE');
export const updateProfile = createAction('UPDATE_PROFILE');
export const getWebhooksEvents = createAction('GET_WEBHOOKS_EVENT');
export const getSecretKeyCommunication = createAction(
  'GET_SECRET_KEY_COMMUNICATION',
);
export const resetSecretKeyCommunication = createAction(
  'RESET_SECRET_KEY_COMMUNICATION',
);
export const setSecretKeyCommunication = createAction(
  'SET_SECRET_KEY_COMMUNICATION',
);
export const getMediaSecretKeyCommunication = createAction(
  'GET_MEDIA_SECRET_KEY_COMMUNICATION',
);
export const resetMediaSecretKeyCommunication = createAction(
  'RESET_MEDIA_SECRET_KEY_COMMUNICATION',
);
export const setMediaSecretKeyCommunication = createAction(
  'SET_MEDIA_SECRET_KEY_COMMUNICATION',
);
export const updateUsage = createAction('UPDATE_USAGE');

export const getIntegrations = createAction('GET_INTEGRATIONS');
export const addIntegration = createAction('ADD_INTEGRATION');
export const removeIntegration = createAction('REMOVE_INTEGRATION');
